<template>
    <div class="top-breadcrumbs">
        <p @click="handleGoIndex">运营指南</p>
        <div class="breadcrumbs-icon"></div>
        <span>众筹基础知识</span>
    </div>
    <div class="cont top">
        <div class="title">什么是摩点众筹?</div>
        <p>摩点众筹聚焦实物类产品众筹。为企业、艺术家或个人提供展示平台，通过用户支持快速获得项目启动资金。平台聚集高粘性、高消费、高复购的年轻用户，为项目发起人提供实现梦想的无限可能。主要聚焦文化创意领域，主要品类：游戏、出版、桌游、潮玩模型、卡牌、科技、设计、动漫、文玩、家居、食品等。</p>
    </div>
    <div class="cont">
        <div class="title">众筹项目要求</div>
        <p>项目需满足<span>原创且独家首发</span>。独家是指产品仅在摩点上架销售。首发是指产品为全网首次发售，全网范围包括线上和线下。</p>
    </div>
    <div class="cont">
        <div class="title">众筹的风险</div>
        <p>需额外注意项目筹资金额的设置。如果最终未达到目标金额，<span>则众筹失败，资金原路给支持者退回，</span>项目发起者是没有收益的，所以项目的目标金额设置就额外重要哦。</p>
    </div>
    <div class="cont img">
        <div class="title">众筹的流程</div>
        <img src="https://p6.moimg.net/mdwxapp/guide/basic.png" />
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()
const handleGoIndex = () => {
    if(sessionStorage.getItem('guide_pro_id')){
        router.push(`/project_manage/index/${sessionStorage.getItem('guide_pro_id')}`)
    } else {
        router.push((`/project_manage/index`))
    }
}
</script>

<style lang="scss" scoped>
.top-breadcrumbs{
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    padding: 0 0 40px 0;
    p{
        color: #7F7F7F;
        cursor: pointer;
    }
    .breadcrumbs-icon{
        width: 14px;
        height: 14px;
        margin: 0 10px;
        background: url('~@/assets/images/icon_right.png') no-repeat center center;
        background-size: contain;
    }
    span{
        color: #1A1A1A;
    }
}
.cont{
    margin: 60px 0 0 0;
    color: #1A1A1A;
    &.top{
        margin: 0;
    }
    &.img{
        .title{
            margin: 0;
        }
    }
    .title{
        font-size: 24px;
        font-weight: 600;
        margin: 0 0 15px 0;
    }
    p{
        font-size: 14px;
        line-height: 21px;
        span{
            font-weight: 600;
        }
    }
    img{
        width: 100%;
        height: auto;
    }
}
</style>